import { render, staticRenderFns } from "./AlternativeFilters.vue?vue&type=template&id=66e1e88e&"
import script from "./AlternativeFilters.vue?vue&type=script&lang=js&"
export * from "./AlternativeFilters.vue?vue&type=script&lang=js&"
import style0 from "./AlternativeFilters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports